import React from 'react';
import PropTypes from 'prop-types';
import ClassNames from 'classnames';
//Mui components
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import RobotIcon from '@mui/icons-material/Android';
import EvolutionIcon from '@mui/icons-material/ShowChart';
import BellIcon from '@mui/icons-material/Notifications';
//Style
import useStyles from 'components/tables/ControlTowerTable/ControlTowerTable.style';
//Pcp components
import ControlTowerRow from 'components/tables/ControlTowerTable/ControlTowerRow';

const ControlTowerTable = ({ changeAction, displayDoneRow, site }) => {

    const classes = useStyles();

    const { items, id, supervisorAction } = site;

    const handleClickIcon = (action) => {

        const ids = [];
        if (!displayDoneRow) {
            items.forEach((item) => {
                item.associatedItems.filter(i => i.supervisorAction === '' || i.supervisorAction === 'NONE').forEach((associatedItem) => ids.push({
                    article_id: associatedItem.articleId,
                    account_id: associatedItem.accountId,
                    item_id: item.id
                }));
            });
        } else {
            items.forEach((item) => {
                item.associatedItems.forEach((associatedItem) => ids.push({
                    article_id: associatedItem.articleId,
                    account_id: associatedItem.accountId,
                    item_id: item.id
                }));
            });
        }

        changeAction(action, ids, id, true, {});
    };

    return (
        <Table className={classes.table}>
            <TableHead>
                <TableRow>
                    <TableCell className={classes.productNameCell}>Product name</TableCell>
                    <TableCell className={classes.cell}>Account</TableCell>
                    <TableCell className={classes.iconCell}>Logs</TableCell>
                    <TableCell className={classes.iconCell}>Params</TableCell>
                    <TableCell
                        className={ClassNames(classes.cell, supervisorAction === 'VALIDATE_BEFORE' ? classes.selectedPriceCellContent : classes.hoverPriceCellContent)}
                        onClick={() => handleClickIcon('VALIDATE_BEFORE')}>
                            Before (Raw)
                    </TableCell>
                    <TableCell
                        className={ClassNames(classes.cell, supervisorAction === 'VALIDATE_BOT' ? classes.selectedPriceCellContent : classes.hoverPriceCellContent)}
                        onClick={() => handleClickIcon('VALIDATE_BOT')}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <RobotIcon className={ClassNames(classes.icon)} style={{ marginRight: '4px' }}/>
                            (Raw)
                        </div>
                    </TableCell>
                    <TableCell className={classes.cell}><EvolutionIcon className={classes.icon} /></TableCell>
                    <TableCell
                        className={ClassNames(classes.cell, supervisorAction === 'VALIDATE_NOW' ? classes.selectedPriceCellContent : classes.hoverPriceCellContent)}
                        onClick={() => handleClickIcon('VALIDATE_NOW')}>
                        Now (Raw)
                    </TableCell>
                    <TableCell className={classes.cell}>Now</TableCell>
                    <TableCell className={classes.iconCell}>
                        <BellIcon className={ClassNames(classes.icon, supervisorAction === 'SET_NV_BELL' && classes.nvBellIcon)} onClick={() => handleClickIcon('SET_NV_BELL')} />
                    </TableCell>
                    <TableCell className={classes.iconCell}>URL</TableCell>
                    <TableCell className={classes.iconCell}>Data</TableCell>
                </TableRow>
            </TableHead>
            <TableBody className={classes.siteName}>
                {items.map((item, key) =>
                    <ControlTowerRow
                        displayDoneRow={displayDoneRow}
                        key={key}
                        item={item}
                        changeAction={changeAction}
                        siteId={id}/>
                )}
            </TableBody>
        </Table>
    );
};

ControlTowerTable.propTypes = {
    changeAction: PropTypes.func,
    displayDoneRow: PropTypes.bool,
    site: PropTypes.object
};

export default ControlTowerTable;
